import "./index.scss";
import "monday-ui-react-core/dist/main.css";

import ReactDOM from "react-dom/client";

import { App } from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
